import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RouterEventsService {
  isPreviewPage$ = new BehaviorSubject<boolean>(false);
}
